import React from "react";

export const TableReporteOpenData = ({ data }) => {
  return (
    <table className="content-table_geomedellin">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Origen</th>
          <th>Tipo</th>
          <th>Recurso</th>
          <th>Temática</th>
        </tr>
      </thead>

      <tbody>
        {data.length > 0 ? (
          data.map((element, index) => (
            <>
              <tr>
                <td>{element.fecha_registro}</td>
                <td>{element.origen_estadistica_txt}</td>
                <td>{element.tipo_estadistica}</td>
                <td>{element.nombre_fuente_dato}</td>
                <td>{element.nombre_tematica}</td>
              </tr>
            </>
          ))
        ) : (
          <tr>
            <td colSpan={5}>Sin resultados para mostrar.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
